export default {
    RESET_BLUEPRINT: "RESET_BLUEPRINT",
    UPDATE_CONSTRUCTS: 'UPDATE_CONSTRUCTS'
}
